import { DataCollectionCollection as Data } from '@/typings/api/DataCollection'

import { dateFormatter } from '@/helpers/dateFormatter'
// eslint-disable-next-line object-curly-newline
import { DELETE, EDIT, HISTORY, VIEW, ADD } from '@/helpers/enums/table-actions'
import { FormdataStatuses, getFormdataStatusText } from '@/typings/api/Formdata'


export const TABLE_ACTIONS = Object.freeze([
  HISTORY,
  {
    ...VIEW,
    tooltip: 'Список ревизий',
  },
  {
    ...EDIT,
    tooltip: 'Сменить доступность для заполнения',
    getFilter: ({ status, id }) => (!status || status !== FormdataStatuses.archive) && id,
  },
  {
    ...ADD,
    tooltip: 'Создать форму',
    getFilter: ({ id }) => !id,
  },
  DELETE,
])

export const CURATOR_TABLE_ACTIONS = Object.freeze([
  {
    ...VIEW,
    tooltip: 'Посмотреть форму',
  },
])

export const TABLE_HEADERS = Object.freeze([
  {
    text: 'Логин',
    value: 'username',
    sortable: false,
    // getRoute: (data: Record<string, unknown>) => ({
    //   name: USERS_ROUTES.VIEW,
    //   params: {
    //     id: data.user_id,
    //   },
    // }),
  },
  {
    text: 'Пользователь',
    value: 'user_full_name',
    sortable: false,
    cellClass: 'BTablePublicationFormdata__user',
  },
  {
    text: '',
    value: 'status',
    sortable: false,
    width: 20,
  },
  {
    text: 'Статус',
    value: 'is_submitted',
    sortable: true,
    width: 130,
    field: getFormdataStatusText,
  },
  {
    text: 'Дата начала работы',
    value: 'created_at',
    sortable: true,
    width: 155,
    field: (value: Data['created_at']) => (
      value && dateFormatter(value)
    ),
  },
  {
    text: 'Дата подачи',
    value: 'submitted_at',
    sortable: true,
    width: 144,
    field: (value: Data['submitted_at']) => (
      value && dateFormatter(value)
    ),
  },
])
